import { SxProps, Theme } from '@mui/material';

export const modalContainerStyles: SxProps<Theme> = {
  position: 'fixed',
  top: '50%',
  left: 'calc(100% + 50px)',
  transform: 'translateY(-50%)',
  zIndex: 1300,
};

export const modalPaperStyles: SxProps<Theme> = {
  borderRadius: 2,
  width: 600,
  position: 'relative',
};

export const modalHeaderStyles: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  px: 2,
  py: 1.5,
};

export const modalContentStyles: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.grey[100],
  borderRadius: 1,
  padding: 2,
  margin: 2,
};

export const closeIconStyles: SxProps<Theme> = {
  fontSize: 20,
};

export const teamChipStyles: SxProps<Theme> = {
  borderRadius: 2,
  color: (theme) => theme.palette.text.primary,
  fontSize: (theme) => theme.typography.body2.fontSize,
  padding: (theme) => theme.spacing(0.5, 1),
  display: 'flex',
  alignItems: 'center',
  '& .MuiChip-avatar': {
    width: 8,
    height: 8,
  },
};

export const teamsAutocompleteStyles: SxProps<Theme> = {
  backgroundColor: (theme) => theme.palette.paper.background,
  borderRadius: 1,
  padding: 0.5,
  '& .MuiOutlinedInput-root': {
    padding: 0.8,
  },
};

export const editorStyles: SxProps<Theme> = {
  '.ck-editor__editable_inline': {
    backgroundColor: (theme) => `${theme.palette.background.paper} !important`,
    borderRadius: '8px !important',
    border: (theme) => `1px solid ${theme.palette.divider} !important`,
    padding: (theme) => `${theme.spacing(1)} !important`,
  },
  '.ck.ck-editor__top.ck-reset_all': {
    display: 'block !important',
  },
  '.ck.ck-toolbar': {
    backgroundColor: 'transparent',
  },
  '.ck.ck-sticky-panel__content': {
    border: 'none !important',
  },
};
